import { computed, ref } from "vue";

const stack = ref<HTMLElement[]>([]);

const activeTarget = computed<HTMLElement | null>(
    () => stack.value[stack.value.length - 1] ?? null,
);

function register(el: HTMLElement) {
    if (!stack.value.includes(el)) {
        stack.value = [...stack.value, el];
    }
}

function unregister(el: HTMLElement) {
    stack.value = stack.value.filter((e) => e !== el);
}

export function useAuroraStage() {
    return { activeTarget, register, unregister };
}
